import React, { useState, useRef } from "react";

import { useIntersection } from "../../hooks/useIntersectionObserver";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
 .loadingPreview{
     width:270px;
     height:100%;    
     display:flex;
     align-items:center;
     justify-content:center;
     animation-name: backgroundColorPalette;
     animation-duration: 0.7s;
     animation-iteration-count: infinite;
     animation-direction: alternate;
 }
 .w100{
     width:100%
 }
 @keyframes backgroundColorPalette {
    0% {
      background: #f9f9f9;
    }
   50%{
       backgroud:#bababa;
   }
    100% {
      background:#adadad
    }
  }
 `;

const ImageRenderer = ({ url, thumb, width, height }) => {
  const [isInView, setIsInView] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef();
  useIntersection(imgRef, () => {
    setIsInView(true);
  });
  const handleOnLoad = (e) => {
    setIsLoaded(true);
  };

  return (
    <>
      <GlobalStyle />

      <div className="w100 nft__item_preview" ref={imgRef}>
        {isInView && (
          <img className="image" src={url} alt="nft" onLoad={handleOnLoad} />
        )}

        {isInView && !isLoaded && <div className="image loadingPreview"></div>}
      </div>
    </>
  );
};

export default ImageRenderer;
